import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoaderService } from "./loader.service";
import { Mail } from "../model/email";
import { Observable, map, tap } from "rxjs";
import { ActionResult } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class EmailService {
  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private environmentService: EnvironmentService
  ) {}

  sendEmailToUser(email?: Mail): Observable<ActionResult<boolean>> {
    this.loaderService.startLoading();
    return this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/public/mail/send", email).pipe(
      tap(() => this.loaderService.dismissLoading()),
      map(value => value ?? { result: false })
    );
  }
}
